module.exports = __webpack_public_path__ + "img/3.8534e7c9.png";